import Sound from 'pixi-sound';
import SoundGroup from "./SoundGroup";
import GlobalDispatcher from "Engine/events/GlobalDispatcher";

/**
 * Класс упарвления звуками в игре
 */
export default new class SoundManager {
    constructor() {
        this.sound = null;
        this._groups = {};

        this._blurMutedState = {};

        this.addListeners();

        this._getSound();
        this.addNewSoundGroup('default');
    }

    addListeners() {
        window.addEventListener('focus', this.onFocus.bind(this));
        window.addEventListener('blur', () =>
            TweenMax.delayedCall(20, () => this.onBlur()
                , [true], this, true));
    }

    onFocus() {
        for (let param in this.groups) {
            if (this._blurMutedState.hasOwnProperty(param)) {
                this.muteGroup(param, this._blurMutedState[param]);
            }
        }
        this._blurMutedState = {};

        //this.muteGroup('music', false);
        //this.muteGroup('default', false);
    }

    onBlur() {
        this._blurMutedState = {};
        for (let param in this.groups) {
            this._blurMutedState[param] = this.groups[param].muted;
            this.muteGroup(param, true);
        }

        //this.muteGroup('music', true);
        //this.muteGroup('default', true);
    }

    /**
     * Получить текущий звуковой файл
     * @private
     */
    _getSound() {
        this.sound = Sound;
    }

    /**
     * Воспроизвести звук по имени
     * @param alias имя звука
     * @param volume
     * @param loop
     * @param groupName
     */
    play(alias, volume = 1, loop = false, groupName = 'default') {
        let sound = this.getSound(alias);
        if (sound) {
            let instance = sound.play({loop: loop, volume: volume});
            sound.baseVolume = volume;
            this.addSoundToGroup(sound, alias, groupName);
            return instance;
        }
    }

    /**
     * Остановить звук по имени
     * @param alias имя звука
     */
    stop(alias) {
        let sound = this.getSound(alias);
        if (sound) {
            let instance = sound.stop();
            return instance;
        }
    }

    /**
     *
     * @param alias
     */
    pause(alias) {
        let sound = this.getSound(alias);
        if (sound.isPlaying) {
            this.sound.pause(alias);
        }
    }

    /**
     *
     * @param alias
     */
    resume(alias) {
        let sound = this.getSound(alias);
        if (sound && !sound.isPlaying) {
            this.sound.resume(alias);
        }
    }

    /**
     *
     * @param groupName
     * @param value
     */
    muteGroup(groupName, value) {
        let group = this.getGroup(groupName);
        if (group) {
            if (value === undefined) {
                group.switchMuted();
            } else {
                group.muted = value;
            }
        }
    }

    /**
     *
     * @param groupName
     * @param value
     */
    volumeGroup(groupName, value) {
        let group = this.getGroup(groupName);
        if (group) {
            group.volume = value;
        }
    }

    /**
     *
     * @param alias
     * @returns {*}
     */
    getSound(alias) {
        return this.sound.find(alias);
    }

    /**
     *
     * @param groupName
     */
    addNewSoundGroup(groupName) {
        if (!this.groups.hasOwnProperty(groupName)) {
            this._groups[groupName] = new SoundGroup(groupName);
        }
    }

    /**
     *
     * @param sound
     * @param alias
     * @param groupName
     */
    addSoundToGroup(sound, alias, groupName) {
        let group = this.getGroup(groupName);
        group.addSound(sound, alias);
    }

    getGroup(groupName) {
        if (!this.groups.hasOwnProperty(groupName)) {
            this.addNewSoundGroup(groupName);
        }
        return this.groups[groupName];
    }

    /**
     *
     * @returns {*}
     */
    get groups() {
        return this._groups;
    }
}
